import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  pastOpportunities: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('pastOpportunities');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.pastOpportunities.length > 0 ? action.pastOpportunities : [];  
  return updateObject(state, {
    pastOpportunities: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, pastOpportunities:[] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PAST_OPPORTUNITIES_START:
      return fetchStart(state);
    case actionTypes.FETCH_PAST_OPPORTUNITIES_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_PAST_OPPORTUNITIES_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
